const DEMO_DOMAIN_PARTS = ["demo", "aavo", "io"];

/** Local worktrees serve the tenant deployed in the clone slot from this hostname. */
const LOCAL_CLONE_HOSTNAME = "127.0.0.1";
export const LOCAL_CLONE_CUSTOMIZATION_NAME = "localClone";

export function resolveTenantCustomizationName(hostname: string): string {
	if (hostname === LOCAL_CLONE_HOSTNAME) {
		return LOCAL_CLONE_CUSTOMIZATION_NAME;
	}
	const hostnameParts = hostname.toLowerCase().split(".");
	if (
		hostnameParts.length === DEMO_DOMAIN_PARTS.length + 1 &&
		hostnameParts.slice(1).every((part, index) => part === DEMO_DOMAIN_PARTS[index])
	) {
		return "demo1";
	}
	return hostnameParts[0]!;
}
